var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductHunt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.858,
    fill: "#D85637"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1819 14.7729H28.7879C32.9719 14.7729 36.3637 18.0436 36.3637 22.0781C36.3637 26.1127 32.9719 29.3833 28.7879 29.3833H22.7273V35.2275H18.1819V14.7729ZM22.7273 25.0002V19.1561H28.7879C30.4615 19.1561 31.8182 20.4643 31.8182 22.0781C31.8182 23.692 30.4615 25.0002 28.7879 25.0002H22.7273Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductHunt);
export default __webpack_public_path__ + "static/media/Product Hunt.12feae02ecf19a1f34e3903b34283506.svg";
export { ForwardRef as ReactComponent };